"use strict";

/**
 * Mess-Modul-Events.
 * @enum {string}
 */
gc.gis.module.GCMeasureEvent = {
	/**
	 * Zeigt an, dass ein Messobjeket verändert wurde.
	 * @event gc.gis.module.GCMeasureEvent#change:measure
	 * @property {gc.gis.module.GCMeasureObject} measure
	 */
	MEASURE_CHANGED: 'change:measure',
	/**
	 * Zeigt an, dass der Layer geleert wurde (z.B. über die Aktion Zeichenfläche leeren).
	 * @event gc.gis.module.GCMeasureEvent#layer:clear
	 */
	LAYER_CLEARED:   'layer:clear'
};

/**
 * @typedef gc.gis.module.GCMeasureObject
 * @name gc.gis.module.GCMeasureObject
 * @property {number} [area=0] Flächeninhalt
 * @property {number} [length=0] Länge
 * @property {gc.gis.module.GCMeasureSegmentObject[]} [segments=[]] Segmentlängen
 * @property {gc.gis.module.GCMeasureSegmentObject[]} [cumulative=[]] Kumulierte Segmentlängen
 * @property {boolean} [isDrawing] Flag, ob aktuell das Messobjekt noch gezeichnet wird
 */

/**
 * @typedef gc.gis.module.GCMeasureSegmentObject
 * @name gc.gis.module.GCMeasureSegmentObject
 * @property {number} value (tatsächlicher) numerischer Wert
 * @property {number} formattedValue Formatierter Wert (ggf. in Einheit konvertiert, begrenzte Kommastellen)
 * @property {string} unit Maßeinheit des Formatierten Werts
 * @property {*} [feature] Featureimplementierung der Kartenbibliothek
 */

/**
 * @classdesc
 * Mess-Modul.
 *
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} [options.map={@link gc.gis.GCApplication#map}]
 * @param {string} [options.label='Messen']
 * @param {boolean} [options.enableSnap=false]
 */
gc.gis.module.GCMeasure = function( options )
{
	gc.gis.module.GCAbstractModule.call( this, options );

	var self = this;

	this.options       = options;
	this.map           = options.map || gc.gis.iface.map;
	this.label         = options.label || 'Messen';

	this._render();

	this._impl = new gc.gis.module.OLMeasureImpl({	// FIXME: ggf. über factory?
		instance: this,
		map:      this.map,
		active:   options.active || false
	});
	this._impl.on(gc.gis.module.GCMeasureEvent.MEASURE_CHANGED, this, function(evt) {
		self.element_panel.onMeasureChanged(evt.measure);
	});
	this._impl.on(gc.gis.module.GCMeasureEvent.LAYER_CLEARED, this, function(evt) {
		self.reset();
	});

	// Interaktion (de-)aktivieren, wenn Panel (in-)aktiv
	gc.gis.iface.ui.sidebar.on(gc.gis.ui.GCSidebarEvent.CONTENT_CHANGED, this, function( evt ) {
		if(evt.newValue === self.launcher_content)
		{
			self.setEnabled(true);
			gc.gis.iface.ui.setInteractionMessage(self.interaction_message);
		}
		else if(evt.oldValue === self.launcher_content)
        {
            self.setEnabled(false);
			// self.reset(); //Inhalt nicht zurücksetzen ggf. soll Messung gedruckt werden
	        gc.gis.iface.ui.unsetInteractionMessage(self.interaction_message);
        }
	});

	// Geräteabhängige Hilfe
	if( gc.gis.iface.env.device === gc.gis.env.device.MOBILE )
	{
		this.interaction_message = {
			title:   'Messen',
			icon:    'touch-pointer',
			message: 'Tippen Sie auf die Karte um einen Punkt hinzuzufügen. '
				+ 'Tippen Sie doppelt auf die Karte um eine Linienmessung abzuschließen. '
				+ 'Für eine Flächenmessung müssen Sie die Fläche schließen.'
		};
	}
	else
	{
		this.interaction_message = {
			title:   'Messen',
			icon:    'mouse-button-left',
			message: 'Klicken Sie mit der linken Maustaste auf die Karte um einen Punkt hinzuzufügen. ' +
				'Mit einem Doppelklick wird die Linienmessung abgeschlossen. ' +
				'Für eine Flächenmessung müssen Sie die Fläche schließen.'
		};
	}

	// Sidebar-Panel
    // this.launcher_content = new gc.gis.ui.GCSidebarContent({
     //    label:   this.label,
     //    'parent': null,
     //    element: this.getElement()
    // });
	// this.launcher = {
	// 	label: this.label,
	// 	icon: 'ms ms-measure-area',
	// 	content: this.launcher_content
	// };
	// gc.gis.iface.ui.sidebar.addLauncher( this.launcher );

    // als Sub-Modul von Tools
    gc.gis.iface.onModuleAvailable(this, 'GCTools', function(module) {
        gc.gis.assert.isInstance(module, gc.gis.module.GCTools);
        self.launcher_content = module.addModule(self, this.getElement(), 'ms ms-measure-area');
    });
};
gc.gis.module.GCMeasure.prototype = Object.create( gc.gis.module.GCAbstractModule.prototype );

/**
 * @return {jQuery}
 */
gc.gis.module.GCMeasure.prototype.getElement = function()
{
	return this.element_panel.getElement();
};

/**
 * @return {jQuery}
 */
gc.gis.module.GCMeasure.prototype._render = function()
{
	var self = this;

	this.element_panel = new gc.gis.module.GCMeasure.Panel({
		module: self,
		active: self.active,
		headline: self.label,
		enableSnap: this.options.enableSnap === true
	});
	return this.element_panel;
};

/**
 * (De-)aktiviert die Karteninteraktion.
 *
 * @public
 * @method
 *
 * @param {boolean} enabled
 */
gc.gis.module.GCMeasure.prototype.setEnabled = function( enabled )
{
	this._impl.setActive(enabled === true);
};

/**
 * Setzt die Ergebnisse zurück.
 *
 * @public
 * @method
 */
gc.gis.module.GCMeasure.prototype.reset = function()
{
	this._impl.clear();
	this.element_panel.resetMeasure();
};

/**
 *
 */
gc.gis.module.GCMeasure.prototype._resetHighlighting = function()
{
	this._impl.resetHighlighting();
};

/**
 *
 */
gc.gis.module.GCMeasure.prototype._highlightSegment = function( feature )
{
	this._impl.highlightSegment( feature );
};

/**
 * TODO
 */
gc.gis.module.GCMeasure.prototype.setSnappingEnabled = gc.gis.abstractMethod;


//////////////
// Aktionen //
//////////////

/**
 *
 */
gc.gis.module.GCMeasureResetAction = function( options )
{
	gc.gis.action.GCAbstractAction.call( this, options );

	var self = this;

	this.module = options.instance;

	this.func = function()
	{
		self.module.reset();
	};
	this.args = [];
};
gc.gis.module.GCMeasureResetAction.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );

